export const MAX_ELEMENTS_COUNT = 1000;

export const SUCCESS_COLOR = 'forestgreen';
export const INACTIVE_COLOR = 'black';
export const ACTIVE_COLOR = 'red';
